export default {
  generalFontSize: '15px',
  generalBodyFontFamily: "'ProximaNova', sans-serif",
  generalBorderRadius: '4px',
  generalHeaderColor: '#0F1821',
  generalHeaderH1FontSize: '20px',
  generalHeaderH1FontWeight: 400,
  generalHeaderH4FontSize: '16px',
  generalHeaderH4FontWeight: 600,
  generalDatePickerTitleDateFontSize: '12px',
  generalDatePickerTitleYearFontSize: '48px',
  generalInputBorder: '1px solid var(--v-accent-base)',
  iconScheduledSuccessSecondaryColor: '#F2994A',
  iconPrivacyPrimaryColor: '#8c94a1',
  cardBorderRadius: '4px',
  btnTextTransform: 'capitalize',
  btnBorderRadius: '5px',
  btnSizeXLarge: '42px',
  btnFontSizesXLarge: '14px',
  btnFontWeight: 400,
  workflowLogoWidth: '142px',
  workflowHeaderPx: '1.75rem',
  workflowHeaderPy: '20px',
  workflowBodyPx: '20px',
  workflowBodyPb: '1.667rem',
  workflowBodyPy: '20px',
  workflowFooterPx: '20px',
  workflowFooterPy: '28px',
  workflowPrivacyTitleMargin: 0,
  workflowPrivacyTitleFontSize: '13px',
  workflowPrivacyTextFontSize: '13px',
  workflowPrivacyTitleColor: 'var(--v-neutralDark-base)',
  workflowPrivacyTextColor: 'rgba(96, 106, 124, 0.7)',
  workflowH1SpanFontWeight: 400,
  workflowH1SpanTextDecoration: 'underline',
  workflowScheduledH1FontSize: '28px',
  workflowScheduledH1FontWeight: 400,
  inputHeight: '46px',
  inputFontSizes: '14px',
  choiceTitleColor: '#fff',
  choiceTitleFontSize: '15px',
  choiceTitleFontWeight: 700,
  choiceTitleLineHeight: '1.5',
  choiceTextMargin: 0,
  choiceTextColor: '#fff',
  choiceTextFontSize: '13px',
  choiceTextFontWeight: 400,
  choiceTextLineHeight: '1.3',
  choiceBorder: 'var(--v-primary-base)',
  choiceBorderHover: 'var(--v-primary-base)',
  choiceBgColor: 'var(--v-primary-base)',
  choiceMoreTitleColor: '#fff',
  choiceSelectedBorder: '1px solid var(--v-accent-base)',
  choiceSelectedBgColor: 'var(--v-primary-base)',
  choiceSelectedTitleColor: '#fff',
  choiceSelectedTextColor: '#fff',
  summaryHeaderColor: '#0F1821',
  summaryHeaderSmsColor: 'rgba(96, 106, 124, 0.7)',
  summaryHeaderSmsFontSize: '12px',
  summaryHeaderSmsFontWeight: 400,
  summaryTextFontSize: '16px',
  summaryTextFontWeight: 400,
  summaryTextColor: 'var(--v-neutralDark-base)',
  summaryEmailContentPadding: '4px',
  summarySmsContentPadding: '3px 4px 25px',
  summaryContentBorder: '1px solid var(--v-accent-base)',
  datetimepikerInputDateMaxwidth: '248px',
  datetimepikerInputTimeMaxwidth: '135px',
};
